import { setUserPermissions } from './set-user-permissions';

/** `PUT /client/:cid/users/:id/permissions {administrator: false}`. */
export const revokeAdminAccess = async (user_id: string): Promise<any> =>
  setUserPermissions(user_id, { administrator: false });
